<template>
  <div class="coupon-card" :class="{'isDetail' : isDetail && !(couponInfo.description || (couponInfo.canUse != undefined && !couponInfo.canUse && couponInfo.reasons && Array.isArray(couponInfo.reasons) && couponInfo.reasons.length > 0))}">
    <div class="coupon-title-wrapper">
      <span class="round-pos l" />
      <span class="round-pos r" />
      <div class="coupon-value" :style="{ width: customWidth }" :class="unavalibleCard">
        <span class="line-pos" />
        <div>
          <div v-if="couponInfo.typeId == 2">
            <span class="face-value">{{ couponInfo.typeFields.off }}</span>
            <span v-if="couponInfo.typeId == 2" class="off">{{ pageConfigGlobal.off }}</span>
          </div>
          <div v-else>
            <span class="cut">{{ symbol }}</span>
            <span class="face-value">{{ couponInfo.typeFields.cut | priceUnitConvert(minorUnit) }}</span>
          </div>
          <div class="coupon-tip">
            <div>{{ $t('featureComponents.page.coupon.on', { feeName: couponInfo.feeName }) }} </div>
            <div>{{ $t('featureComponents.page.coupon.over', { symbol: symbol, price: convertedPrice }) }}</div>
          </div>
        </div>
      </div>
      <div class="coupon-name-wrapper" :class="unavalibleCard">
        <div :class="`coupon-name `">
          <!-- <i :class="`${ couponInfo.style?'class'+couponInfo.style:''}`" /> -->
          {{ couponInfo.name }}
        </div>
        <span :class="timeShowClass" class="coupon-time"><i class="iconfont icon-take-class-time" /><span v-html="timeShow" /></span>
        <div :class="tagClass" class="tag">
          {{ timeStatusText }}
        </div>
      </div>
    </div>
    <div class="coupon-detail-wrapper" :class="unavalibleCard" :title="couponInfo.coupon_datetime">
      <div class="coupon-detail">
        <div class="line-double">
          <div v-if="couponInfo.description || (couponInfo.canUse != undefined && !couponInfo.canUse && couponInfo.reasons && Array.isArray(couponInfo.reasons) && couponInfo.reasons.length > 0)" class="show-wrapper">
            <span class="details-tips"><i class="iconfont icon-img-mark" />{{ pageConfig.details }}</span>
            <div v-if="showDetailInfo" class="details-tips-info">
              {{ couponInfo.description }}
            </div>
            <div v-else-if="couponInfo.canUse != undefined && !couponInfo.canUse && couponInfo.reasons && Array.isArray(couponInfo.reasons) && couponInfo.reasons.length > 0" class="details-tips-info">
              <div class="detail-info">
                <ul class="coupon-cannot-use-reason-list" :class="{'show-list-style': couponInfo.reasons.length > 1}">
                  <li v-for="(reason, index) in couponInfo.reasons" :key="index">
                    {{ couponCannotUseReasonMap(reason, couponInfo) }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="btn-wrapper">
            <span v-if="showRedeemBtn && couponInfo.canUse" class="redeen-btn button button-normal font-semibold">{{ pageConfig.redeem }}</span>
            <div v-if="showSelect && (isSelected || couponInfo.canUse != undefined && couponInfo.canUse)" class="btn-select-coupon" :class="{'selected': isSelected}" @click="selectHandler">
              <i class="iconfont icon-success" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="showDetailInfo" class="detail-collapse-wrapper">
      <div class="detail-info">
        <p class="detail-content">
          {{ couponInfo.description }}
        </p>
      </div>
      <div class="detail-collapse">
        <span class="collapse-title">{{ pageConfig.details }}</span>
        <i class="el-icon-arrow-right collapse-icon" />
      </div>
    </div>
    <div v-else-if="couponInfo.canUse != undefined && !couponInfo.canUse && couponInfo.reasons && Array.isArray(couponInfo.reasons) && couponInfo.reasons.length > 0" class="detail-collapse-wrapper">
      <div class="detail-info">
        <ul class="coupon-cannot-use-reason-list" :class="{'show-list-style': couponInfo.reasons.length > 1}">
          <li v-for="(reason, index) in couponInfo.reasons" :key="index">
            {{ couponCannotUseReasonMap(reason, couponInfo) }}
          </li>
        </ul>
      </div>
      <div class="detail-collapse">
        <span class="collapse-title">{{ pageConfig.details }}</span>
        <i class="el-icon-arrow-right collapse-icon" />
      </div>
    </div> -->
  </div>
</template>
<script>
import filters from 'common/filters';

export default {
  props: {
    couponInfo: {
      default: () => ({}),
      type: Object,
    },
    source: { // order-订单 couponList-优惠券列表 historyList-优惠券历史
      default: '',
      type: String,
    },
    showSelect: { // 是否可选
      default: false,
      type: Boolean,
    },
    // 是否被选中
    isSelected: {
      default: false,
      type: Boolean,
    },
    showTagType: { // 右上角tag显示类型 timeStatus-根据优惠券有效期时间显示，未开始、新到、快过期 useStatus-根据使用状态显示，已使用，未使用，已过期
      default: 'timeStatus',
      type: String,
    },
    showRedeemBtn: { // 是否显示去使用按钮
      default: false,
      type: Boolean,
    },
    showTimeByTimeStatus: { // 是否根据特殊有限期显示时间
      default: false,
      type: Boolean,
    },
    showDetailInfo: { // 是否展示详情折叠面板
      default: true,
      type: Boolean,
    },
    showUnavalible: { // 是否展示不可用蒙版
      default: true,
      type: Boolean,
    },
    canReselect: {
      default: true,
      type: Boolean,
    },
    isDetail: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    const { symbol, minorUnit } = this.$store.state.currency;
    const { timezone } = this.$store.state
    return {
      pageConfig: this.$t('page.couponList'),
      pageConfigGlobal: this.$t('featureComponents.page.coupon'),
      symbol,
      minorUnit,
      timezone,
      dateFormat: this.$t('common.dateFormat'),
      isKeepTwoDecimal: this.$t('common.isKeepTwoDecimal'),
      detailShow: false,
      timeStatusClassMap: this.$t('page.couponList.timeStatusClassMap'),
      useStatusClassMap: {
        1: 'expired',
        2: 'redeemed',
      },
      timeStatusTextMap: this.$t('page.couponList.timeStatusTextMap'),
      locale: this.$store.state.locale,
      weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    }
  },
  computed: {
    timeStatusText() {
      return this.timeStatusTextMap[this.couponInfo.timeStatus]
    },
    tagClass() {
      const {
        couponInfo: { useStatus, timeStatus }, showTagType, timeStatusClassMap, useStatusClassMap,
      } = this
      let tagClass = ''
      if (showTagType === 'timeStatus') tagClass = timeStatusClassMap[timeStatus]
      else if (showTagType === 'useStatus') tagClass = useStatusClassMap[useStatus]
      return tagClass
    },
    timeShow() {
      const {
        showTimeByTimeStatus, couponInfo: { effectStart, effectEnd, timeStatus }, timezone, dateFormat,
      } = this
      // let time = `${filters.resourceDateFormate(effectStart, timezone, dateFormat)}-${filters.resourceDateFormate(effectEnd, timezone, dateFormat)}`
      let time = `${filters.getFormatTime(effectStart, this.locale)}<br>&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${filters.getFormatTime(effectEnd, this.locale)}`
      if (showTimeByTimeStatus) {
        if (Number(timeStatus) === 1) time = `Available since ${filters.resourceDateFormate(effectStart, timezone, dateFormat)}`
        else if (Number(timeStatus) === 3) time = `Expires on ${filters.resourceDateFormate(effectEnd, timezone, dateFormat)}`
      }
      return time
    },
    timeShowClass() {
      const { showTimeByTimeStatus, couponInfo: { timeStatus } } = this
      let showClass = ''
      if (showTimeByTimeStatus) {
        if (Number(timeStatus) === 1) showClass = 'effectStart'
        else if (Number(timeStatus) === 3) showClass = 'effectEnd'
      }
      return showClass
    },
    unavalibleCard() {
      const { couponInfo, showUnavalible } = this
      return !this.canReselect || (showUnavalible && couponInfo.canUse !== null && couponInfo.canUse !== undefined && !couponInfo.canUse) ? 'unavalible-card' : ''
    },
    convertedPrice() {
      return filters.priceUnitConvert(this.couponInfo.typeFields.full, this.minorUnit, this.isKeepTwoDecimal)
    },
    customWidth() {
      // 特殊处理日韩优惠券卡片宽度
      return this.locale === 'jp' || this.locale === 'kr' || this.locale === 'fr' ? '180px' : ''
    },
  },
  methods: {
    // 时间格式
    // getFormatTime(nextLessonTime) {
    //   if (this.locale === 'hk' || this.locale === 'kr' || this.locale === 'jp') {
    //     // const week = this.weekdays[moment(nextLessonTime).format('d')]
    //     const month = this.locale === 'hk' ? moment(nextLessonTime).format('M月D日') : moment(nextLessonTime).format('MMM Do');
    //     const date3 = `${month} ${moment(nextLessonTime).format('dddd')} ${moment(nextLessonTime).format('HH:mm')}`
    //     return date3
    //   }
    //   const clientOptions = JSON.parse(window.localStorage.getItem('clientOptions')) || {}
    //   const date1 = `${moment(nextLessonTime).format('MMM D, ddd')} ${moment(nextLessonTime).format('HH:mm')}` // USA, FR
    //   const date2 = `${moment(nextLessonTime).format('HH:mm')} ${moment(nextLessonTime).format('ddd D MMM')}` // UK

    //   return clientOptions.dateFormat === 'UK' ? date2 : date1
    // },
    selectHandler() {
      this.$emit('select-handler', this.couponInfo)
    },
    couponCannotUseReasonMap(reasonCode, couponInfo = {}) {
      const notReasons = this.pageConfig.cannotUseReason
      let reason = '';
      switch (reasonCode) {
        case '1':
          reason = notReasons['1'];
          break;
        case '2':
          reason = `${notReasons['2']} ${this.symbol}${filters.priceUnitConvert(couponInfo.typeFields.full, this.minorUnit, this.isKeepTwoDecimal)}`;
          break;
        case '3':
          reason = `${notReasons['3']} ${filters.resourceDateFormate(couponInfo.effectStart, this.timezone, this.dateFormat)}`;
          break;
        case '4':
          reason = notReasons['4'];
          break;
        case '7':
          reason = notReasons['7'];
          break;
        case '8':
          reason = notReasons['8'];
          break;
        default:
          break
      }
      return reason;
    },
  },
}
</script>
<style lang="scss" scoped>
.coupon-card {
  margin: 0 0 16px 0;
  background: #fff;
  width: 400px;
  border-radius: 4px;
  border: 1px solid #e7e7e7;

  &.isDetail {
    .round-pos {
      display: none !important;
    }

    .coupon-detail-wrapper {
      display: none !important;
    }
  }

  .coupon-title-wrapper {
    display: flex;
    height: 112px;
    position: relative;

    .round-pos {
      width: 8px;
      height: 16px;
      background: #fafafa;
      border: 1px solid #e7e7e7;
      position: absolute;
      top: 105px;
      z-index: 1;

      &.l {
        left: -1px;
        border-radius: 0 10px 10px 0 / 0 10px 10px 0;
        border-color: #e7e7e7 #e7e7e7 #e7e7e7 #fafafa;
      }

      &.r {
        right: -1px;
        border-radius: 10px 0 0 10px / 10px 0 0 10px;
        border-color: #e7e7e7 #fafafa #e7e7e7 #e7e7e7;
      }
    }

    .coupon-value {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 0 16px;
      width: 147px;
      height: 112px;
      text-align: left;
      color: rgba(255, 133, 10, 1);
      align-items: center;

      .coupon-tip {
        font-size: 12px;
        font-family: Montserrat-Regular, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: 400;
        color: var(--txt-color-link);
        line-height: 14px;
        margin-top: 5px;
      }

      .line-pos {
        width: 1px;
        height: 64px;
        background: #f2f2f2;
        position: absolute;
        top: 24px;
        right: 0;
      }

      .cut,
      .off {
        align-self: center;
        font-size: 20px;
        font-family: Montserrat-SemiBold, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: 600;
        color: var(--txt-color-link);
        line-height: 21px;
        margin-top: 2px;
      }

      .face-value {
        align-self: center;
        font-size: 28px;
        font-family: Montserrat-Bold, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: bold;
        color: var(--txt-color-link);
        line-height: 29px;
      }

      &.unavalible-card::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.8);
      }
    }

    .coupon-name-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 16px;
      width: 272px;
      height: 112px;

      &.unavalible-card::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px 10px 10px 0;
      }

      .coupon-name {
        font-size: 16px;
        font-family: Montserrat-Bold, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: bold;
        color: var(--txt-color-lv1);
        line-height: 20px;
        overflow: hidden;
        word-break: break-word;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        >i {
          display: none;
          width: 24px;
          height: 24px;
          vertical-align: middle;

          &.class1 {
            display: inline-block;
            background: url('~assets/images/coupon/tuition_fee.png') no-repeat;
            background-size: 100%;
            background-position-y: -2px;
          }

          &.class2 {
            display: inline-block;
            background: url('~assets/images/coupon/learning_materials.png') no-repeat;
            background-size: 100%;
            background-position-y: -2px;
          }
        }
      }

      .coupon-time {
        font-size: 12px;
        font-family: Montserrat-Medium, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: 500;
        color: var(--txt-color-lv2);
        line-height: 14px;
        margin-top: 9px;
        white-space: nowrap;

        &.effectStart {
          color: rgba(51, 112, 255, 1);
        }

        &.effectEnd {
          color: rgba(255, 80, 63, 1);
        }

        .iconfont {
          margin-right: 6px;
          vertical-align: top;
          display: inline-block;
        }
      }

      .tag {
        position: absolute;
        top: -1px;
        left: -141px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        font-family: Montserrat-Bold, Montserrat, Arial, Helvetica, sans-serif;
        font-weight: bold;
        color: #fff;
      }

      .new {
        width: 45px;
        background: var(--txt-color-link);
        border-radius: 4px 0 4px 0;
      }

      .available-soon {
        width: 109px;
        background: #3370ff;
        border-radius: 4px 0 4px 0;
      }

      .expire-soon {
        width: 91px;
        background: #ff503f;
        border-radius: 4px 0 4px 0;
      }

      .available-soon-short {
        width: 109px;
        background: #3370ff;
        border-radius: 4px 0 4px 0;
      }

      .expire-soon-short {
        width: 91px;
        background: #ff503f;
        border-radius: 4px 0 4px 0;
      }

      .redeemed {
        width: 60px;
        height: 60px;
        background: url('~assets/images/coupon/redeemed.png') no-repeat;
        background-size: 100%;
        left: auto;
        top: auto;
        right: 0;
        bottom: -56px;
      }

      .expired {
        width: 60px;
        height: 60px;
        background: url('~assets/images/coupon/expired.png') no-repeat;
        background-size: 100%;
        left: auto;
        top: auto;
        right: 0;
        bottom: -56px;
      }
    }
  }

  .coupon-detail-wrapper {
    position: relative;

    &.unavalible-card::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      z-index: 1;
      display: none;
    }

    .coupon-detail {
      position: relative;
      padding: 0 16px;
      height: 57px;

      .line-double {
        padding-top: 12px;
        border-top: 1px dashed #d3d3d3;
        display: flex;
        justify-content: flex-end;
      }

      .show-wrapper {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        align-content: center;
        position: relative;

        .details-tips {
          line-height: 32px;
          font-size: 12px;
          font-family: Montserrat-Regular, Montserrat, Arial, Helvetica, sans-serif;
          font-weight: 400;
          color: var(--txt-color-lv2);
          cursor: pointer;

          .icon-img-mark::before {
            content: '';
            width: 12px;
            height: 12px;
            display: inline-block;
            margin: 11px 5px 0 0;
            vertical-align: top;
            background: url('~assets/images/coupon/icon_mark.png') 0 0/ 100% auto no-repeat;
          }

          &:hover + .details-tips-info {
            display: block;
          }
        }

        .details-tips-info {
          background: #f4f4f4;
          border: 1px solid rgba(151, 151, 151, 0.1);
          width: 268px;
          font-size: 12px;
          font-family: Montserrat-Regular, Montserrat, Arial, Helvetica, sans-serif;
          font-weight: 400;
          color: #a0a0a0;
          line-height: 15px;
          border-radius: 2px;
          padding: 10px;
          position: absolute;
          left: 0;
          top: 38px;
          z-index: 2;
          display: none;

          .coupon-cannot-use-reason-list {
            padding-left: 20px;
          }

          &::after {
            content: '';
            width: 16px;
            height: 10px;
            background: #f4f4f4;
            border: 1px solid rgba(151, 151, 151, 0.1);
            border-width: 1px 0 0 1px;
            -webkit-transform: skewY(90deg);
            -ms-transform: skewY(10px);
            transform: skewX(0deg) skewY(30deg);
            display: block;
            position: absolute;
            left: 5px;
            top: -5px;
          }
        }

        .coupon-tip {
          background: rgba(244, 246, 250, 1);
          border-radius: 5px;
          padding: 4px 6px;
          font-size: 12px;
          font-weight: 500;
          color: var(--txt-color-lv1);
          line-height: 14px;
          white-space: nowrap;
          align-self: center;
          margin-right: 8px;
        }
      }

      .btn-wrapper {
        display: flex;
        height: 32px;
        overflow: hidden;

        .redeen-btn {
          align-self: center;
          width: 91px;
          height: 32px;
          background: var(--txt-color-link);
          border-radius: 24px;
          font-size: 14px;
          font-family: Montserrat-SemiBold, Montserrat, Arial, Helvetica, sans-serif;
          font-weight: 600;
          color: #fff;
          white-space: nowrap;
          padding: 0;

          &:hover {
            background: var(--txt-color-link2);
          }
        }

        .btn-select-coupon {
          position: absolute;
          right: 20px;
          align-self: center;
          width: 22px;
          height: 22px;
          text-align: center;
          background: #f4f6fa;
          border-radius: 50%;
          cursor: pointer;
          z-index: 1;

          .iconfont {
            display: none;
            line-height: 22px;
          }

          &.selected {
            background: var(--txt-color-link);
            color: #fff;

            .iconfont {
              display: block;
            }
          }
        }
      }
    }
  }

  .detail-collapse-wrapper {
    display: flex;
    flex-direction: column;
    background: rgba(222, 226, 231, 0.3);
    padding-top: 10px;
    margin-top: -10px;
    border-radius: 0 0 10px 10px;

    .detail-collapse {
      height: 24px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(162, 170, 184, 1);
      text-align: center;
      align-self: center;
      display: flex;

      .collapse-title {
        align-self: center;
      }

      .collapse-icon {
        margin-left: 4px;
        font-size: 8px;
        align-self: center;
        transform: rotate(0deg);
        transition: transform 0.3s, -webkit-transform 0.3s;
      }
    }

    .detail-info {
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
      bottom: 24px;
      overflow: auto;
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
      color: rgba(162, 170, 184, 1);
      background: #edf0f5;
      padding: 0;
      max-height: 0;
      transition: max-height 0.3s linear;
      will-change: max-height;
      z-index: 2;
      border-radius: 10px;

      .detail-content {
        padding: 10px 16px;
        word-break: break-all;
      }

      .coupon-cannot-use-reason-list {
        padding: 6px 8px;
        list-style: none;

        &.show-list-style {
          list-style: '-' inside;
        }
      }
    }
  }

  .detail-collapse-wrapper:hover {
    .detail-info {
      max-height: 100px;
      overflow: auto;
    }

    .collapse-icon {
      transform: rotate(-90deg);
    }
  }
}
</style>
